import React, { useState } from "react";
import "./PreviewHeader.css";
import { RiFileCloseLine } from "react-icons/ri";

interface PreviewHeaderProps {
    selectedFileName?: string;
    previewData: any[];
    onClear?: () => void;
    isSourceFile?: boolean;
}

const PreviewHeader: React.FC<PreviewHeaderProps> = ({ selectedFileName, previewData, onClear, isSourceFile }) => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const handleClearClick = () => {
        setShowConfirmModal(true);
    };

    const handleConfirmYes = () => {
        setShowConfirmModal(false);
        if (onClear) {
            onClear();
        }
    };

    const handleConfirmNo = () => {
        setShowConfirmModal(false);
    };

    return (
        <>
            <div className="preview-header">
                <div className="preview-header-left">
                    <h2 className="preview-title">
                        <strong>{selectedFileName}</strong> uploaded
                    </h2>
                    <p className="preview-subtitle">{previewData?.length} {isSourceFile ? "results" : "questions"} </p>
                </div>
                <button className="preview-clear-btn" title="Clear files" onClick={handleClearClick}>
                    <RiFileCloseLine size={20} />
                </button>
            </div>

            {showConfirmModal && (
                <div className="confirm-modal-overlay">
                    <div className="confirm-modal">
                        <div className="confirm-modal-body">
                            <p>Are you sure you want to clear preview data?</p>
                        </div>
                        <div className="confirm-modal-footer">
                            <button className="confirm-btn confirm-btn-no" onClick={handleConfirmNo}>
                                No
                            </button>
                            <button className="confirm-btn confirm-btn-yes" onClick={handleConfirmYes}>
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PreviewHeader;
